
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { empty, singleton, append, delay, toArray } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../../../Widgets/Table/Types.js";
import { defaultArg } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { reactApi, reactElement } from "../../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { UserManagementTab, UserManagementOverviewTabs } from "../../OverviewTabs.js";
import { TableControl$1, Table } from "../../../../Widgets/Table/Table.js";
import { singleton as singleton_1, ofArray, toArray as toArray_1 } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { RouterModule_nav, RouterModule_encodeParts } from "../../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import User_Add_Plus from "../../../../../public/assets/icons/User_Add_Plus.svg";
import { React_useElmish_Z6C327F2E } from "../../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../../../Components/Skeleton.js";

function ApiReceiversOverview(props) {
    let elems, TableRows, Options;
    const t = useTranslation()[0];
    const columnDefinitions = toArray(delay(() => append(singleton(new ColumnDefinition$1("name", "", t("general.name"), (dto) => (new CellContent(0, [dto.Name])), "text", "text")), delay(() => (props.AccountSettings.BusinessUnitsEnabled ? singleton(new ColumnDefinition$1("businessUnitName", "", t("business_units.business_unit"), (dto_1) => (new CellContent(0, [defaultArg(dto_1.BusinessUnitName, "")])), "select", "text")) : empty())))));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems = [createElement(UserManagementOverviewTabs, {
        RestEnabled: props.AccountSettings.RestEnabled,
        SelectedTab: new UserManagementTab(1, []),
    }), createElement(Table, (TableRows = toArray_1(props.ApiReceivers), (Options = {
        BorderStyle: "row",
        CSVDownload: false,
        ConfigurableColumns: false,
        CustomTableFilters: false,
        DefaultSortColumn: ["name", "asc"],
        Fullscreen: false,
        GlobalSearch: true,
        OnRowClick: new OnTableRowClick$1(1, [(dto_2) => RouterModule_encodeParts(ofArray(["settings", "user-management", "api", dto_2.Id]), 1)]),
        RowSelection: "disabled",
        SaveTableConfiguration: false,
    }, {
        ColumnDefinitions: columnDefinitions,
        Controls: singleton_1(new TableControl$1(t("settings.user_management.api_receiver.overview.new_api_receiver"), User_Add_Plus(), (_arg) => {
            RouterModule_nav(ofArray(["settings", "user-management", "api", "new"]), 1, 1);
        }, false, false, "api-receiver-create")),
        Options: Options,
        TableKey: "not-defined-table",
        TableRows: TableRows,
    })))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function ApiReceiversOverviewView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const matchValue = patternInput[0].ApiReceivers;
    if (matchValue.tag === 0) {
        return createElement(Skeleton, {
            Variant: "table",
        });
    }
    else {
        return createElement(ApiReceiversOverview, {
            AccountSettings: props.AccountSettings,
            ApiReceivers: matchValue.fields[0],
            Dispatch: patternInput[1],
            UserData: props.UserData,
        });
    }
}

